/**
 * 精简版 RBush，兼容 Cesium RectangleCollisionChecker 所需 API：
 * insert / remove / collides
 * （避免 webpack 打包 rbush@4 ESM/UMD 出问题）
 */
export default class RBush {
  constructor() {
    this.data = [];
  }

  clear() {
    this.data = [];
    return this;
  }

  insert(item) {
    if (item) this.data.push(item);
    return this;
  }

  remove(item, equalsFn) {
    if (!item) return this;
    const idx = this.data.findIndex((x) =>
      equalsFn ? equalsFn(item, x) : x === item
    );
    if (idx !== -1) this.data.splice(idx, 1);
    return this;
  }

  collides(bbox) {
    for (let i = 0; i < this.data.length; i++) {
      const a = this.data[i];
      if (
        bbox.minX <= a.maxX &&
        bbox.minY <= a.maxY &&
        bbox.maxX >= a.minX &&
        bbox.maxY >= a.minY
      ) {
        return true;
      }
    }
    return false;
  }

  search(bbox) {
    return this.data.filter(
      (a) =>
        bbox.minX <= a.maxX &&
        bbox.minY <= a.maxY &&
        bbox.maxX >= a.minX &&
        bbox.maxY >= a.minY
    );
  }

  all() {
    return this.data.slice();
  }
}
